<template>
  <div>
    <v-container>
      <h1>Partition Management</h1>

      <v-card class="mb-4"
              :loading="accountLoading">
        <v-card-title>
          Sync Account
        </v-card-title>
        <v-card-text>
          <ValidationObserver tag="span" v-slot="{}" ref="observer1">
            <form @submit.prevent="syncAccount">
              <v-row>
                <v-col md="12" lg="12">
                  <ValidationProvider :rules="accountIdRules" v-slot="{ errors }" name="AccountId">
                    <TextInput
                      style="margin-top: 0px;"
                      label="Submission Number(s) (comma separated - max 1,000) e.g. SUB000123456,SUB000654321"
                      name="Account"
                      :clearable="true"
                      :short="true"
                      col="12"
                      :errors="errors"
                      :value="accountId"
                      :maxlength="15000"
                      @change="accountId = $event"
                      >
                    </TextInput>
                  </ValidationProvider>
                </v-col>
                <v-col md="6"
                       lg="8">
                  <FormButton label="Submit" size="x-large" @click="syncAccount" :disabled="accountLoading" />
                </v-col>
              </v-row>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>

       <v-card class="mb-4"
              :loading="agentLoading">
        <v-card-title>
          Sync Amlink User
        </v-card-title>
        <v-card-text>
          <ValidationObserver tag="span" v-slot="{}" ref="observer2">
            <form @submit.prevent="syncAgent">
              <v-row>
                <v-col md="6" lg="4">
                  <ValidationProvider :rules="idRules" v-slot="{ errors }" name="AmlinkHumanId">
                    <TextInput
                      style="margin-top: 0px;"
                      label="Amlink Human Id"
                      name="Agent"
                      :clearable="true"
                      :short="true"
                      col="12"
                      :errors="errors"
                      type="number"
                      :min="1"
                      :value="humanId"
                      @change="humanId = $event"
                      >
                    </TextInput>
                  </ValidationProvider>
                </v-col>
                <v-col md="6"
                       lg="8">
                  <FormButton label="Submit" size="x-large" @click="syncAgent" :disabled="agentLoading" />
                </v-col>
              </v-row>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>

    </v-container>
  </div>
</template>

<script>
  import FormButton from '@/components/form/FormButton.vue';
  import { AccountService } from '@/api/AccountService';
  import { AgentService } from '@/api/AgentService';
  import TextInput from '@/components/form/TextInput.vue';
  import { ValidationProvider } from 'vee-validate';
import { max } from 'moment';

  export default {
    name: 'PartitionManagement',
    components: {
      FormButton,
      TextInput
    },
    data () {
      return {
        accountId: "",
        humanId: "",
        idRules: 'required|min_value:1',
        accountIdRules: 'required',
        accountLoading: false,
        agentLoading: false
      };
    },
    methods: {
      syncAccount () {
        this.$refs.observer1.refs.AccountId.validate()
          .then((valid) => {
            if (valid) {
              this.accountLoading = true;
              AccountService.sync({ body: { accountIds: this.accountId } })
                .then((response) => {
                  if (response) {
                    this.$store.dispatch('toastSuccess', { Message: 'Account Sync Request Complete' });
                  } else {
                    this.$store.dispatch('toastError', { Message: 'Error Syncing Account' });
                  }
                })
                .finally(() => {
                  this.accountLoading = false;
                });
            }
          });
      },
      syncAgent () {
        this.$refs.observer2.refs.AmlinkHumanId.validate()
          .then((valid) => {
            if (valid) {
              this.agentLoading = true;
              AgentService.sync({ humanId: this.humanId })
                .then((response) => {
                  if (response) {
                    this.$store.dispatch('toastSuccess', { Message: 'Agent Sync Request Complete' });
                  } else {
                    this.$store.dispatch('toastError', { Message: 'Error Syncing Agent' });
                  }
                })
                .finally(() => {
                  this.agentLoading = false;
                });
            }
          });
      }
    }
  };
</script>
